import { ScreenDimensionsComponent } from '../../shared/components/screen-dimension-calculator/screen-dimension-component';
import { Component, inject, signal, Renderer2, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StoragePrefix } from '@core/constant';
import { StorageService } from 'src/app/utils';

@Component({
  selector: 'app-maintenance',
  imports: [
    TranslateModule,
    CommonModule,
  ],
  templateUrl: './maintenance-component.html',
  styleUrls: ['./maintenance-component.scss'],
})
export class MaintenanceComponent implements OnInit {
  _storage = inject(StorageService);
  constructor(
    private location: Location,
    public translate: TranslateService,
    private renderer: Renderer2
  ) { }

  headerH = 220;
  private readonly minH = 180;
  private readonly maxH = 360;
  private readonly k = 0.25;
  screenWidth = signal(window.innerWidth);
  screenHeight: number = 0;
  public screenDimensionService = inject(ScreenDimensionsComponent);


  ngOnInit() {
    this.renderer.listen('window', 'resize', this.onResize.bind(this));
    const saved = this._storage.get(StoragePrefix.LANGUAGE) || 'en';
    this.translate.setDefaultLang('en');
    this.translate.use(saved);
    document.dir = saved === 'ar' ? 'rtl' : 'ltr';
    try {
      document.documentElement.lang = saved;
    } catch { }

  }


  onResize(event: Event): void {
    this.screenWidth.set(window.innerWidth);
  }

  get currentLang(): string {
    const lang = this._storage.get(StoragePrefix.LANGUAGE || 'en');
    return lang
  }
}
